import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ExportToQuickbooksComponent } from './export-to-quickbooks.component';
import { SharedModule } from 'app/shared/shared.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from 'app/material.module';
import { ExportDetailsComponent } from './export-details/export-details.component';
import { PurchaseInvoiceProductsComponent } from './purchase-invoice-products/purchase-invoice-products.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgScrollbarModule,
        FlexLayoutModule,
        MaterialModule,
        RouterModule,
        SharedModule
    ],
    declarations: [
        ExportToQuickbooksComponent,
        ExportDetailsComponent,
        PurchaseInvoiceProductsComponent
    ]
})
export class ExportToQuickbooksModule { }


